class DZ_RevealAnimations {
    constructor() {
        window.sr = ScrollReveal({
            mobile: false
        });

        /*sr.reveal('.about-content', { delay: 100, origin: 'right', duration: 750 });
        sr.reveal('.about-image', { delay: 100, origin: 'left', duration: 750 });
        sr.reveal('.contact-phone', { delay: 100, origin: 'left', duration: 750 });
        sr.reveal('.contact-hours', { delay: 100, origin: 'right', duration: 750 });
        sr.reveal('.testimonials-item', { delay: 100, origin: 'bottom', duration: 750 }, 125);
        sr.reveal('.grid img', { delay: 100, origin: 'bottom', duration: 750 }, 125);*/
    }
}
